import axiosFetch from './config';


export const getAddress = async () => {
  let token = localStorage.getItem('token')
  return axiosFetch({
    method: 'GET',
    url: `/address`,
    headers: {
      Authorization: 'Bearer ' + token,
    },
  })
}

export const CreateAddress = async (data) => {
  let token = localStorage.getItem('token')
  return axiosFetch({
    method: 'POST',
    data,
    url: '/address',
    headers: {
      Authorization: 'Bearer ' + token,
    },
  });
};

export const postAddress = async (data) => {
  let token = localStorage.getItem('token')
  return axiosFetch({
    method: 'POST',
    data,
    url: '/address',
    headers: {
      Authorization: 'Bearer ' + token,
    },
  });
};

export const putAddress = async (data) => {
  let token = localStorage.getItem('token')
  return axiosFetch({
    method: 'PUT',
    data,
    url: '/address',
    headers: {
      Authorization: 'Bearer ' + token,
    },
  });
};

export const updateAddress = async (data) => {
  let token = localStorage.getItem('token')
  return axiosFetch({
    method: 'PUT',
    data,
    url: '/address',
    headers: {
      Authorization: 'Bearer ' + token,
    },
  });
};

export const deleteAddressById = async (AddressId) => {
  let token = localStorage.getItem('token')
  return axiosFetch({
    method: 'DELETE',
    url: `/address/${AddressId}`,
    headers: {
      Authorization: 'Bearer ' + token,
    }
  })
}

